import { BaseItem } from './common';

export enum FailureReason {
  // catch all for export failure
  ExportFailure = 'EXPORT_FAILURE',
  // failed to enqueue job message
  JobCreationFailure = 'JOB_CREATION_FAILURE',
  // export client failed to initialize
  ExportClientInitializationFailure = 'EXPORT_CLIENT_INITIALIZATION_FAILURE',
  // actual value and expected value differ
  ValidationFailure = 'VALIDATION_FAILURE',
  // failed to get actual value
  ValidationExtractFailure = 'VALIDATION_EXTRACT_FAILURE',
  // validation failed to save to datastore
  ValidationSaveFailure = 'VALIDATION_SAVE_FAILURE',
  MultipleXRays = 'MULTIPLE_X-RAYS',
  // validation failed on interpretations only
  InterpretationValidationFailure = 'INTERPRETATION_VALIDATION_FAILURE',
  // patient status not reset after order export
  RestorePatientStatusFailure = 'RESTORE_PATIENT_STATUS_FAILURE',
  // conflict with another user while exporting
  MultipleUserConflict = 'MULTIPLE_USER_CONFLICT',
  // admin manually cancelled import/export
  ManuallyCanceled = 'MANUALLY_CANCELED',
  // chart content has been unexpectedly modified since last fetch
  EditConflict = 'EDIT_CONFLICT',
  NotImplemented = 'NOT_IMPLEMENTED',
  MessageExpiration = 'MESSAGE_EXPIRATION',
  // for any unsupported fields, notes will be kicked back to content needs review
  UnsupportedFields = 'UNSUPPORTED_FIELDS',
  ExtractProblemGroupsFailure = 'EXTRACT_PROBLEM_GROUPS_FAILURE',
  EncounterCanceled = 'ENCOUNTER_CANCELED',
  EncounterSigned = 'ENCOUNTER_SIGNED',
  EncounterFuture = 'ENCOUNTER_FUTURE',
}

export enum Event {
  Created = 'CREATED',
  FailedCreating = 'FAILED_CREATING',
  Published = 'PUBLISHED',
  Received = 'RECEIVED',
  Started = 'STARTED',
  Nacked = 'NACKED',
  CompletedSuccessfully = 'COMPLETED_SUCCESSFULLY',
  CompletedUnsuccessfully = 'COMPLETED_UNSUCCESSFULLY',
}

interface BaseRpaJobEvent {
  rpaJobId: string;
  event: Event;
  workerName: string | null;
  branchName: string | null;
  gitHash: string | null;
  reasons: string[] | null;
  exceptions: string[] | null;
  screenshotGsPaths: string[] | null;
  videoGsPath: string | null;
}

export interface RpaJobEvent extends BaseItem, BaseRpaJobEvent {}
